import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import cn from "classnames";
import { FaWhatsapp } from "react-icons/fa";

import { Leg } from "services/action";

import {
  Page,
  DetailShipmentCard,
  MapBox,
  LoadingScreen,
  DeniedScreen,
} from "ui/components";

import {
  formatDate,
  waFormat,
  currencyFormat,
  UTCFormat,
} from "utilities/common";
import { isValidDate } from "utilities/common";

const DetailShipment = ({ match, location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services["Leg.Show"]
  );

  const { manifest_id, manifest_type } = location?.state;

  const [denied, setDenied] = React.useState(false);
  const [data, setData] = React.useState(null);
  const [show, setShow] = React.useState(false);
  const [jobs, setJobs] = React.useState([]);
  const [totalCOD, setTCOD] = React.useState(0);

  const $onLoad = async (id) => {
    const req = await Dispatch(Leg.$show(manifest_id, id));

    if (req?.message === "success") {
      if (req?.data !== null) {
        setData(req?.data);
      } else {
        setDenied(true);
      }
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  React.useEffect(() => {
    const totalCODValue = data?.jobs?.reduce((total, job) => {
      const codValue = job?.delivery_order?.shipment?.cod_value || 0;
      return total + codValue;
    }, 0);

    setTCOD(totalCODValue);
  }, [data]);

  React.useEffect(() => {
    let jobs = [];

    if (show) {
      data?.jobs?.forEach((result) => {
        jobs.push(result?.id);
      });
    }

    setJobs(jobs);
  }, [show]);

  if (StateLoading) {
    return <LoadingScreen />;
  }

  if (denied) {
    return <DeniedScreen />;
  }

  const ListHorizontal = ({ title, content, className }) => {
    const c = cn(
      className ? className : "",
      "row py-1 mb-1 list-item m-0 align-items-start fsz-12 border-bottom"
    );

    return (
      <div className={c}>
        <div className="col-4 p-0 fsz-12">{title}</div>
        <div className="col-1 p-0 fsz-12">:</div>
        <div className="col-7 p-0 text-start title fsz-12">{content}</div>
      </div>
    );
  };

  const Departure = () => {
    const $handleSubmit = async () => {
      const payload = {
        atd_at: UTCFormat(
          formatDate(new Date(), "YYYY-MM-DD"),
          formatDate(new Date(), "HH:mm")
        ),
      };

      const req = await Dispatch(
        Leg.$departure(manifest_id, data?.id, payload)
      );
      if (req?.message === "success") {
        $onLoad(data?.id);
      }
    };

    return (
      <Button
        type="button"
        variant="primary"
        className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
        onClick={$handleSubmit}
      >
        Menuju titik
      </Button>
    );
  };

  const Loading = () => {
    return (
      <Button
        type="button"
        variant="primary"
        className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
        onClick={() => {
          History.push({
            pathname: "/pod",
            state: {
              type: "loading",
              data: data,
              leg_id: data?.id,
              leg_type: data?.type,
              manifest_id: manifest_id,
              manifest_type: manifest_type,
            },
          });
        }}
      >
        Muat Barang
      </Button>
    );
  };

  const Delivered = () => {
    return (
      <Button
        type="button"
        variant="success"
        className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
        onClick={() =>
          History.push({
            pathname: "/pod",
            state: {
              type: "delivered",
              data: data,
              leg_id: data?.id,
              leg_type: data?.type,
              manifest_id: manifest_id,
              manifest_type: manifest_type,
              cod_value: totalCOD,
              is_receive: data?.is_receive,
            },
          })
        }
      >
        Telah Diterima
      </Button>
    );
  };

  const Disputed = () => {
    return (
      <Button
        type="button"
        variant="danger"
        className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
        onClick={() =>
          History.push({
            pathname: "/pod",
            state: {
              type: "disputed",
              leg_id: data?.id,
              leg_type: data?.type,
              manifest_id: manifest_id,
            },
          })
        }
      >
        Gagal Kirim
      </Button>
    );
  };

  const Arrival = () => {
    const $handleSubmit = async () => {
      const payload = {
        ata_at: UTCFormat(
          formatDate(new Date(), "YYYY-MM-DD"),
          formatDate(new Date(), "HH:mm")
        ),
      };

      const req = await Dispatch(Leg.$arrival(manifest_id, data?.id, payload));
      if (req?.message === "success") {
        $onLoad(data?.id);
      }
    };

    return (
      <Button
        type="button"
        variant="primary"
        className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
        onClick={$handleSubmit}
      >
        Sampai Tujuan
      </Button>
    );
  };

  const Collect = () => {
    return (
      <Button
        type="button"
        variant="success"
        className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
        onClick={() =>
          History.push({
            pathname: "/collect",
            state: {
              data: data,
              leg_id: data?.id,
              manifest_id: manifest_id,
              cod_value: totalCOD,
            },
          })
        }
      >
        Terima COD
      </Button>
    );
  };

  const renderMap = () => {
    let map = <MapBox destination={data?.location} data={data} />;
    return map;
  };

  const handleChecklist = (id) => {
    // Check if the item is already in the list of checked items
    if (jobs.includes(id)) {
      // If it's in the list, remove it
      setJobs(jobs.filter((job) => job !== id));
    } else {
      // If it's not in the list, add it
      setJobs([...jobs, id]);
    }
  };

  const nextStep = () => {
    History.push({
      pathname: "/pod",
      state: {
        type: "loading",
        leg_id: data?.id,
        leg_type: data?.type,
        manifest_id: manifest_id,
        jobs: jobs,
      },
    });
  };

  return (
    <Page
      title={`Detail`}
      backTo={() => History.goBack()}
      action={
        <div>
          {data?.status === "new" && <Departure />}{" "}
          {data?.status === "departed" && <Arrival />}
          {data?.type === "pickup" &&
            data?.status === "arrived" &&
            !isValidDate(data?.loading_at) && <Loading />}
          {data?.status === "arrived" && data?.type === "drop_point" && (
            <div className="row">
              {data?.is_receive ? (
                <div className="col-12">
                  <Delivered />
                </div>
              ) : (
                <>
                  <div className="col-6">
                    <Delivered />
                  </div>
                  <div className="col-6">
                    <Disputed />
                  </div>
                </>
              )}
            </div>
          )}
          {((data?.status === 'delivered' || data?.status === 'partial_delivered') && !data?.is_receive && data?.cod_value > 0 && data?.cod_status === 'pending') && (
            <Collect />
          )}
        </div>
      }
    >
      <div>{renderMap()}</div>
      <div className="py-2 pb-5">
        <DetailShipmentCard title="Detil Lokasi">
          <ListHorizontal
            title="Tujuan"
            content={
              <div>
                <div style={{ fontWeight: "bold" }}>{data?.location?.name}</div>
                <div style={{ alignItems: "baseline", marginVertical: 5 }}>
                  <div>{data?.location?.phone_number}</div>
                </div>
                <div
                  className="badge bg-success text-white px-3"
                  onClick={() =>
                    window.open(
                      `https://wa.me/${waFormat(data?.location?.phone_number)}`,
                      "_blank"
                    )
                  }
                >
                  <div className="d-flex align-items-center flex-row py-3">
                    <FaWhatsapp size={15} />
                    <div>Contact</div>
                  </div>
                </div>
              </div>
            }
          />
          <ListHorizontal
            title="Alamat"
            content={
              <div>
                <div style={{ fontWeight: "bold" }}>
                  {data?.location?.address}
                </div>
                <div>
                  {data?.location?.region?.village_name},{" "}
                  {data?.location?.region?.district_name},{" "}
                  {data?.location?.region?.regency_name},{" "}
                  {data?.location?.region?.province_name}
                </div>
              </div>
            }
          />

          {isValidDate(data?.atd_at) && (
            <ListHorizontal
              title="Tanggal Keberangkatan"
              content={formatDate(data?.atd_at, "DD/MM/YYYY, HH:mm")}
            />
          )}

          {isValidDate(data?.ata_at) && (
            <ListHorizontal
              title="Tanggal Kedatangan"
              content={formatDate(data?.ata_at, "DD/MM/YYYY, HH:mm")}
            />
          )}

          {isValidDate(data?.loading_at) && (
            <ListHorizontal
              title="Tanggal Muat"
              content={formatDate(data?.loading_at, "DD/MM/YYYY, HH:mm")}
            />
          )}

          {data?.disputed_note && (
            <ListHorizontal
              title="Dispute Note"
              content={
                <div style={{ fontWeight: "bold" }}>{data?.disputed_note}</div>
              }
            />
          )}
        </DetailShipmentCard>

        {data?.type === "pickup" && (
          <DetailShipmentCard title="Daftar Pickup">
            {data?.jobs && (
              <div>
                {data?.jobs?.map((d, key) => (
                  <div
                    className="row py-2"
                    key={key}
                    style={{
                      borderBottom: "0.5px solid #202020",
                    }}
                  >
                    <div className="col-1 fw-semibold" style={{ fontSize: 11 }}>
                      {key + 1}
                    </div>
                    <div className="col-4">
                      <div style={{ fontSize: 11 }} className="fw-semibold">
                        {d?.delivery_order?.shipment?.code}
                      </div>
                      <div style={{ fontSize: 9 }}>
                        ORD: {d?.delivery_order?.order?.code}
                      </div>
                      {d?.delivery_order?.shipment?.ref_code && (
                        <div style={{ fontSize: 9 }}>
                          REF: {d?.delivery_order?.shipment?.ref_code}
                        </div>
                      )}
                    </div>
                    <div className="col-5">
                      <div style={{ fontSize: 11 }} className="fw-semibold">
                        {d?.destination?.name}
                      </div>
                      <div style={{ fontSize: 9 }}>
                        {d?.destination?.region?.district_name},{" "}
                        {d?.destination?.region?.regency_name},{" "}
                        {d?.destination?.region?.province_name}
                      </div>
                    </div>
                    <div className="col-2">
                      <div style={{ fontSize: 11 }} className="fw-semibold">
                        {currencyFormat(
                          d?.delivery_order?.shipment?.total_weight
                        )}{" "}
                        KG
                      </div>
                      <div style={{ fontSize: 9 }}>
                        {d?.delivery_order?.shipment?.total_quantity} Koli
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </DetailShipmentCard>
        )}

        {data?.type === "drop_point" && data?.jobs && (
          <div>
            <div className="d-flex flex-row align-items-end justify-content-between mb-2">
              <div className="fw-bold">
                Total Shipment ({data?.jobs?.length})
              </div>
            </div>

            {data?.jobs?.map((job, key) => (
              <DetailShipmentCard title={`Shipment (${key + 1})`} key={key}>
                <ListHorizontal
                  title="Kode"
                  content={
                    <div>
                      <div style={{ fontWeight: "bold" }}>
                        {job?.delivery_order?.shipment?.code}
                      </div>
                      <div
                        style={{
                          alignItems: "baseline",
                          marginVertical: 5,
                          fontSize: 10,
                        }}
                      >
                        ORD: {job?.delivery_order?.order?.code}
                      </div>
                    </div>
                  }
                />

                {job?.delivery_order?.shipment?.ref_code ? (
                  <ListHorizontal
                    title="Kode Referensi"
                    content={
                      <div style={{ fontWeight: "bold" }}>
                        {job?.delivery_order?.shipment?.ref_code}
                      </div>
                    }
                  />
                ) : null}

                <ListHorizontal
                  title="Shipper"
                  content={
                    <div style={{ fontWeight: "bold" }}>
                      {job?.delivery_order?.shipment?.shipper?.name}
                    </div>
                  }
                />

                {job?.delivery_order?.shipment?.cod_value > 0 && (
                  <ListHorizontal
                    title="COD"
                    content={
                      <div style={{ fontWeight: "bold" }}>
                        {currencyFormat(
                          job?.delivery_order?.shipment?.cod_value,
                          "Rp"
                        )}
                      </div>
                    }
                  />
                )}

                <ListHorizontal
                  title="ETA"
                  content={
                    <div style={{ fontWeight: "bold" }}>
                      {formatDate(
                        job?.delivery_order?.shipment?.eta_at,
                        "DD MMM YYYY, HH:mm"
                      )}
                    </div>
                  }
                />

                <div className="mt-3">
                  {job?.delivery_order?.shipment?.items && (
                    <div>
                      <div className="row bg-light  border border-1 border-secondary mx-1">
                        <div className="col-6 text-center fw-semibold border-end border-secondary p-2">
                          Nama Barang
                        </div>
                        <div className="col-3 text-center fw-semibold border-end border-secondary p-2">
                          QTY
                        </div>
                        <div className="col-3 text-center fw-semibold p-2">
                          {!data?.is_receive ? "QTY Terkirim" : "Berat (Kg)"}
                        </div>
                      </div>

                      {job?.delivery_order?.shipment?.items?.map(
                        (item, key) => (
                          <div
                            className="row border border-1 border-top-0 border-secondary mx-1"
                            key={key}
                          >
                            <div className="col-6 text-center fw-semibold border-end border-secondary p-2">
                              {item?.item_name}
                            </div>
                            <div className="col-3 text-center fw-semibold border-end border-secondary p-2">
                              {item?.quantity}{" "}
                              {!data?.is_receive &&
                                `(${currencyFormat(item?.weight)} Kg)`}
                            </div>

                            <div className="col-3 text-center fw-semibold p-2">
                              {!data?.is_receive
                                ? item?.quantity_delivered
                                  ? currencyFormat(item?.quantity_delivered)
                                  : "-"
                                : currencyFormat(item?.weight)}
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              </DetailShipmentCard>
            ))}
          </div>
        )}

        <Modal
          show={show}
          onHide={() => {
            setJobs([]);
            setShow(false);
          }}
          backdrop="static"
          size="small"
          enforceFocus={true}
          dialogClassName="sc-modals"
        >
          <Modal.Header closeButton>
            <div className="fw-bold text-uppercase">Daftar Pickup</div>
          </Modal.Header>
          <Modal.Body className="bg-white">
            {data?.jobs && (
              <div>
                {data?.jobs?.map((d, key) => (
                  <label
                    className="row py-2"
                    key={key}
                    style={{
                      borderBottom: "0.5px solid #202020",
                    }}
                  >
                    <div className="col-1 fw-semibold" style={{ fontSize: 11 }}>
                      <input
                        type="checkbox"
                        onChange={() => handleChecklist(d?.id)}
                        checked={jobs.includes(d?.id)}
                        style={{ transform: "scale(1.5)", marginTop: 5 }}
                      />
                    </div>
                    <div className="col-4">
                      <div style={{ fontSize: 11 }} className="fw-semibold">
                        {d?.delivery_order?.shipment?.code}
                      </div>
                      <div style={{ fontSize: 9 }}>
                        ORD: {d?.delivery_order?.order?.code}
                      </div>

                      {d?.delivery_order?.shipment?.ref_code && (
                        <div style={{ fontSize: 9 }}>
                          REF: {d?.delivery_order?.shipment?.ref_code}
                        </div>
                      )}
                    </div>
                    <div className="col-5">
                      <div style={{ fontSize: 11 }} className="fw-semibold">
                        {d?.destination?.name}
                      </div>
                      <div style={{ fontSize: 9 }}>
                        {d?.destination?.region?.district_name},{" "}
                        {d?.destination?.region?.regency_name},{" "}
                        {d?.destination?.region?.province_name}
                      </div>
                    </div>
                    <div className="col-2">
                      <div style={{ fontSize: 11 }} className="fw-semibold">
                        {currencyFormat(
                          d?.delivery_order?.shipment?.total_weight
                        )}{" "}
                        KG
                      </div>
                      <div style={{ fontSize: 9 }}>
                        {d?.delivery_order?.shipment?.total_quantity} Koli
                      </div>
                    </div>
                  </label>
                ))}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="bg-white">
            <button className="btn btn-success btn-sm" onClick={nextStep}>
              Selanjutnya
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </Page>
  );
};

export default DetailShipment;
